import { TableFieldModel } from '@/model/TableList'
import { numberTimes, priceWithoutRate, totalPriceWithoutRate } from '@/utils/index'
// import { MarketFeeAccountFieldData } from '@/views/business/businessList/businessMarketFee/FieldTable'

export const TableField: TableFieldModel[] = [

  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessNo',
    fieldName: '业务编号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'customerCompanyContact.name',
    fieldName: '收款人',
    convert: context => context.rowData?.customerCompanyContact?.name || ''
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'paymentTime',
    fieldName: '付款时间'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'paymentAccount',
    fieldName: '付款账户'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'account.alias',
    fieldName: '收款账户',
    convert: context => context.rowData?.account?.alias || ''
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'mark',
    fieldName: '申请备注'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'customerCompany',
    fieldName: '公司名称'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'ticketCompany',
    fieldName: '所属公司'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'fee',
    fieldName: '费用',
    isMoney: true,
    textAlign: 'right',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'feeType',
    fieldName: '费用类型'// 系统生成，人工生成
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'type',
    fieldName: '类型',
    width: 130
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'status',
    fieldName: '状态',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'approveUser',
    fieldName: '审批人'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'approveTime',
    fieldName: '审批时间'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'times',
    fieldName: '申请次数',
    width: 130
  },
  // ...MarketFeeAccountFieldData,
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessName',
    fieldName: '业务名称'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessBrand',
    fieldName: '业务品牌'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessModel',
    fieldName: '型号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessSerial',
    fieldName: '序列号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessAmount',
    fieldName: '数量'
  },
  // 业务订单税费
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee2',
    fieldName: '单价(未税)',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const { orderFee } = rowData.business
      if (!orderFee) {
        return ''
      }
      const { orderTaxRate } = rowData.business
      return priceWithoutRate(orderFee, true, orderTaxRate)
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee',
    fieldName: '单价(含税)',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const { orderFee } = rowData.business
      if (!orderFee) {
        return ''
      }
      return orderFee
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee3',
    fieldName: '总价(未税)',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const {
        orderFee,
        orderTaxRate
      } = rowData.business
      if (!orderFee) {
        return ''
      }
      const { businessAmount } = rowData
      return totalPriceWithoutRate(orderFee, businessAmount, true, orderTaxRate)
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee4',
    fieldName: '总价(含税)',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const { orderFee } = rowData.business
      if (!orderFee) {
        return ''
      }
      const { businessAmount } = rowData
      return numberTimes(orderFee, businessAmount, true)
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessUnit',
    fieldName: '单位',
    width: 60
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessSalesMan',
    fieldName: '业务员'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessStatus',
    fieldName: '业务状态',
    width: 100,
    convert: context => {
      const { rowData } = context
      return rowData.business.status
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessReceivedStatus',
    fieldName: '收款状态',
    width: 100,
    convert: context => {
      const { rowData } = context
      return rowData.business.receivedStatus
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'paymentMark',
    fieldName: '付款备注'
  }
]
